import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import services from "../services/indexService";
import useToast from "../hooks/useToast";
import { formatToYyyyMmDd } from "../../utils/formats";
import AlertPopup from "../components/index/AlertPopup";
import { appInsights } from "../../telemetry/telemetryService";

export const taskPaneInitailValue = {
        // Index
        docDescription: "",
        documentClass: "",
        documentType: "",
        receivedDate: "",
        chkQuoteSentToProducer: false,
        useFileName: false,
        docNotes:  "",
        // task
        taskChecked: false,
        taskSubject: "",
        sameAsDocDesc: false,
        taskQueue: "",
        taskType: "",
        taskNote: "",
        taskDueDate: "",
        taskStartDate: "",
        taskPriority: "",
        checklistItem: ""
      }
const TaskPaneContext = createContext({
  selectedGridItem: [],
  selectedItemDetailFromGrid: null,
  setSelectedGridItem: (_selectedItems) => {},
  queues: [],
  setQueues: (_queues = []) => {},
  userGroups: [],
  setUserGroups: (_values = []) => {},
  user: [],
  setUsers: (_values = []) => {},
  taskTypes: [],
  setTaskTypes: (_values = []) => {},
  taskPaneState: {
    searchText: null,
    compId: null,
    comLocId: null,
    criteria: null,
    insuredId: null,
    userId: null,
    userGroupId: null,
    taskTypeId: null,    
   },
   accessToken: null,
});

export const TaskPaneProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
  const [taskPaneState, setTaskPaneState] = useState({
    searchText: null,
    compId: null,
    comLocId: null,
    criteria: null,
    insuredId: null,
    userId: null,
    userGroupId: null,
  });
  //
  const [accessToken, setAccessToken] = useState(null);
  const isDialog = new URLSearchParams(window.location.search).get("dialog") === "true";
  //
  const { notify, Toaster } = useToast();
  const [profileDetails, setProfileDetails] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [policiesDetailsForInsured, setPoliciesDetailsForInsured] = useState([]);
  const [selectedGridItem, setSelectedGridItem] = useState([]);
  const [documentType, setDocumentType] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [documentClass, setDocumentClass] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [queues, setQueues] = useState([]);
  const [user, setUsers] = useState([]);
  const [taskTypes, setTaskTypes] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [open, setOpen] = useState(false);
    const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const getPoliciesDetailsForInsuredData = 
    async (InsuredID, SubmissionStatusID, LoggedInCompLocID, ViewAllCompLocs) => {
      setPoliciesDetailsForInsured([]);
      setSelectedGridItem([]);
      setTaskPaneState((prev) => ({ ...prev }));
      try {
        const result = await services.getPoliciesDetailsForInsured(
          InsuredID,
          SubmissionStatusID,
          LoggedInCompLocID,
          ViewAllCompLocs,
          taskPaneState?.userId
        );
        if(!!result && result?.length) {
          setSelectedGridItem(result?.length ? new Set([ taskPaneState?.isEmailSub? taskPaneState?.policyId : result[0]?.policyID]) : []);
        setPoliciesDetailsForInsured(result);
        setTaskPaneState((prev) => ({ ...prev, isEmailSub: false }));
        return result;
      } else {
          setTitle("Search result");
          setText("No policy details found");
          // setOpen(true);
          }
      } catch (e) {
        console.log("policy list", e);
        if(e?.response?.status === 403) {
          setTitle(e?.response?.data?.error === "AccessDenied"? "Access Denied" : "Search Failed")
          setText(e?.response?.data?.message)
          // setOpen(true);
          }
        setTaskPaneState((prev) => ({ ...prev}));
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
      }
    }
        useEffect(() => {
          if(taskPaneState.comLocId)
            getPriorityList();
        }, [taskPaneState.comLocId]);
  
  const getPriorityList = async () => {
    try {
      const result = await services.getPriorityList();
      setPriorityList(result);
    } catch (e) {
      setPriorityList([]);
      console.log(e);
    }
  };
  const filterTypeByCriteriaType = useMemo(
    () =>
      taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Policy #"|| taskPaneState?.criteria  === "Submission #"
        ? "Type Insured/Policy"
        : taskPaneState?.criteria === "Producer #" || taskPaneState?.criteria === "Producer Name"
          ? "Type Producer"
          : "Type claim",
    [taskPaneState?.criteria]
  );

  const selectedItemDetailFromGrid = useMemo(() => {
    if (filterTypeByCriteriaType === "Type Insured/Policy" && policiesDetailsForInsured) {
      const selectedPolicy = policiesDetailsForInsured?.find((item) => item.policyID === [...selectedGridItem][0]);
      setTaskPaneState((prev) => ({ 
        ...prev, 
        // receivedDate: formatToYyyyMmDd(selectedPolicy?.receiveDate),
        chkQuoteSentToProducer: !!selectedPolicy?.chkQuoteSentToProducer ?? false,
        unlockchkQuoteSentToProducer: !!selectedPolicy?.unlockchkQuoteSentToProducer ?? false,
        policychkQuoteSentToProducer: !!selectedPolicy?.policychkQuoteSentToProducer ?? false,
        //docDescription: selectedPolicy?.docDescription?.length ? selectedPolicy.docDescription.substring(0, 60) : "",
        //documentType: selectedPolicy?.documentType ?? "",
        // useFileName: !!selectedPolicy?.useFileName ?? false,
        //documentClass: selectedPolicy?.documentClass ?? "",
        // emailSubject: selectedPolicy?.emailSubject ?? "",
        docNotes: selectedPolicy?.docNotes?.length ? selectedPolicy?.docNotes.substring(0, 255) : "", 

        useChecklistItem:  false,
        docDescription: prev?.useChecklistItem? "" : prev?.docDescription,
        sameAsDocDesc: (!!prev?.useChecklistItem && !!prev?.sameAsDocDesc)? false : !!prev?.sameAsDocDesc,
        taskSubject: (!!prev?.useChecklistItem && !!prev?.sameAsDocDesc)? "" : prev?.taskSubject,
       }));
      return selectedPolicy;
    } else {
        const selectedProducer = policiesDetailsForInsured?.find((item) => item.producerId === [...selectedGridItem][0]);
      return {
        ProducerID: selectedProducer?.producerId,
        policyNumber: "",
        lob: "",
      };
    }
  }, [selectedGridItem, policiesDetailsForInsured, filterTypeByCriteriaType]);
  
  useEffect(() => {
 if(selectedItemDetailFromGrid?.policyID && taskPaneState.comLocId && taskPaneState.userId && taskPaneState.documentType) {
  getIndexFormDetails(taskPaneState?.documentType, taskPaneState.comLocId, !!localStorage.getItem("actionType"), selectedItemDetailFromGrid?.policyID, null, taskPaneState.userId, taskPaneState.emailSubject)
 } else {
  if(!selectedItemDetailFromGrid?.ProducerID && !selectedItemDetailFromGrid?.policyID) {
    setTaskPaneState((prev) => ({ ...prev, ...taskPaneInitailValue, userGroupId: prev?.profileUserGroupId, userGroup: prev?.userId }));
  }
 }
  }, [taskPaneState?.documentType, selectedItemDetailFromGrid?.policyID]);

  const getIndexFormDetails =async (imgKeywordId,
    CompLocID,
    EmailIndex,
    policyID,
    policyDetailId,
    userId,
    txtSubject) => {
    try {
      //notify("progress");
      const result = await services.GetIdsByImageKeywordSelect(
       imgKeywordId,
        CompLocID,
        (EmailIndex && !!txtSubject),
        policyID,
        policyDetailId,
        userId,
        txtSubject
      );
      setTaskPaneState((prev) => ({
        ...prev,
        docDescription: result?.docDescription?.length? result?.docDescription.substring(0, 60): "",
        documentClass: result?.documentClassID ?? "",
        // documentType: result?.imgKeywordID ?? "",
        // receivedDate: formatToYyyyMmDd(result?.receiveDate),
        // chkQuoteSentToProducer: result?.chkQuoteSentToProducer ?? false,
        useFileName: result?.docDescription?.length? false : prev?.useFileName,
        useChecklistItem: result?.docDescription?.length? false : prev?.useChecklistItem,
        emailSubject: result?.subject ? result?.subject: taskPaneState?.emailSubject,
        // docNotes: result?.docNotes ?? "",
        // task
        taskChecked: result?.chkTask,
        taskSubject: result?.txtSubject?.length? result?.txtSubject.substring(0, 60): "",
        sameAsDocDesc: (result?.docDescription?.length || result?.txtSubject?.length)? false : prev?.sameAsDocDesc,
        userGroupId: result?.userGroupID? result?.userGroupID : taskPaneState?.profileUserGroupId,
        userGroup: result?.assignedId ? result?.assignedId : taskPaneState?.userId,
        taskQueue: result?.imgCommonQueueID,
        taskType: result?.taskTypeID,
        // taskNote: result?.docNotes?? "",
        taskDueDate: result?.dueDateOnly,
        taskStartDate: result?.startDateOnly,
        taskPriority: result?.priorityID
      }));
    } catch (e) {
      //notify("error", "Failed to fetch GetIdsByImageKeywordSelect data");
      console.log(e);
    }
  }
  const getDocumentType = async (comLocId) => {
    try {
      const result = await services.getDocumentType(comLocId);
      setDocumentType(result);
    } catch (e) {
      setDocumentType([]);
      console.log(e);
    }
  };

    const getDocumentClass = async (comLocId, criteria) => {
    try {
      const result = await services.getDocumentClass(criteria, comLocId, false);
      setDocumentClass(result);
    } catch (e) {
      setDocumentClass([]);
      console.log(e);
    }
  };

  const getUserGroupsForPerson = async (userId) => {
    try {
      const result = await services.getUserGroupsForPerson(userId);
      setUserGroups(result);
      setTaskPaneState((prev) => ({ ...prev}));
    } catch (e) {
      console.log(e);
      setUserGroups([]);
    }
  };
  const getQueuesForUserGroup = async (userGroupId) => {
    try {
      const result = await services.getQueuesForUserGroup(userGroupId);
      setQueues(result);
      setTaskPaneState((prev) => ({ ...prev }));
    } catch (e) {
      console.log(e);
      setQueues([]);
    }
  };

  const getPersonUserGroupXRef = async (userGroupId, activeOnly, activeAndExpiredWithOpenTask) => {
    try {
      const result = await services.getPersonUserGroupXRef(
        userGroupId,
        activeOnly,
        activeAndExpiredWithOpenTask
      );
      setUsers(result);
      setTaskPaneState((prev) => ({ ...prev }));
    } catch (e) {
      setUsers([]);
      console.log(e);
    }
  };
  const getCheckList = async (PolicyId, Completed, CompLocID, IncludeNone) => {
    try {
      setTaskPaneState((prev) => ({ ...prev, checklistItem: "" }));
      const result = await services.getPolicyChecklistForPolicy(
        PolicyId,
        Completed,
        CompLocID,
        IncludeNone
      );
      setCheckList(result);
    } catch (e) {
      setCheckList([]);
      setTaskPaneState((prev) => ({ ...prev, checklistItem: "" }));
    }
  };
  const getTaskTypes = async (userGroupId) => {
    try {
      const result = await services.getTaskTypes(0, userGroupId);
      setTaskTypes(result);
    } catch (e) {
      setTaskTypes([]);
    }
  };
  useEffect(() => {
    if (taskPaneState.comLocId) {
      getDocumentType(taskPaneState.comLocId);
    }
  }, [taskPaneState.comLocId]);

    useEffect(() => {
    if (taskPaneState.comLocId && taskPaneState.criteria) {
      getDocumentClass(taskPaneState.comLocId, taskPaneState.criteria);
    }
  }, [taskPaneState.comLocId, taskPaneState.criteria]);
  useEffect(() => {
    if (taskPaneState?.insuredId && taskPaneState.comLocId && (taskPaneState?.criteria  === "Policy #" || taskPaneState?.criteria  === "Insured"|| taskPaneState?.criteria  === "Submission #")) {
      if(!taskPaneState?.isSearch) getPoliciesDetailsForInsuredData(taskPaneState?.insuredId, -1, taskPaneState.comLocId, false);
      else setTaskPaneState((prev) => ({ ...prev, isSearch: false  }));
    }
  }, [taskPaneState?.insuredId]);

  //   useEffect(() => {
  //   if (taskPaneState?.insuredId && taskPaneState.comLocId && filterTypeByCriteriaType === "Type Insured/Policy") {
  //     getPoliciesDetailsForInsuredData(taskPaneState?.insuredId, -1, taskPaneState.comLocId, true);
  //   }
  // }, [taskPaneState?.criteria]);

  //   useEffect(() => {
  //   if (!!taskPaneState?.useFileName) {
  //     setTaskPaneState((prev) => ({ ...prev, docDescription: "", sameAsDocDesc: false  }));
  //   }
  // }, [taskPaneState?.useFileName]);

  useEffect(() => {
    if (taskPaneState.userId && taskPaneState?.compLocId) {
      getUserGroupsForPerson(taskPaneState.userId);
    }
  }, [taskPaneState.userId, taskPaneState?.compLocId]);
  useEffect(() => {
    if (taskPaneState.userGroupId) {
      getQueuesForUserGroup(taskPaneState.userGroupId);
      getPersonUserGroupXRef(taskPaneState.userGroupId, true, false);
      getTaskTypes(taskPaneState.userGroupId);
    } else {
      setQueues([]);
      setUsers([]);
      setTaskTypes([]);
    }
  }, [taskPaneState.userGroupId]);

  useEffect(() => {
    if(taskPaneState?.comLocId && taskPaneState?.userId)
      getCheckList(selectedItemDetailFromGrid?.policyID, false, taskPaneState?.comLocId, true)
  }, [taskPaneState?.comLocId, taskPaneState?.userId, selectedItemDetailFromGrid?.policyID]);

    const getLocationSpecificInfo = async (comLocId, compId, userId= taskPaneState?.userId, criteria="") => {
      try {
        // const userId = taskPaneState?.userId;
        // notify("progress");
              setTaskPaneState((prev) => ({
          ...prev,
          criteria: "",
          insuredId: ""
        }));
        const result = await services.getLocationSpecificInfo(
          comLocId,
          compId,
          userId,
          -1,
          comLocId,
          false,
          false
        );
        notify("success", "LocationSpecificInfo data fetch successful!");
        setTaskPaneState((prev) => ({ 
          ...prev, 
          ...result, 
          criteria: criteria? criteria: result?.criteriaItems[0]?.criteriaName ?? "",
          insuredId: result?.insuredForRecentPoliciesResults[0]?.insuredID?? "",
          useFileName: result?.chkTask?? false,
         }));
        // setDocumentType(result?.documentTypesResults || []);
      } catch (e) {
        notify("error", "Failed to fetch LocationSpecificInfo data");
        console.log(e);
        appInsights.trackDependencyData({
          target: process.env.BASE_URL,
          name: "Excel_LocationSpecificInfo_Payload",
          dependencyTypeName: "HTTPS",
          success: false,
          responseCode: e?.status || 500,
          properties: {
            bodyData: {
              comLocId,
              compId,
              userId: taskPaneState.userId,
            },
            error: e,
            userId: taskPaneState.userId
          }
        });
      }
      };

  return (
    <TaskPaneContext.Provider
      value={{
        profileDetails,
        setProfileDetails,
        locationData,
        setLocationData,
        taskPaneState,
        setTaskPaneState,
        policiesDetailsForInsured,
        setPoliciesDetailsForInsured,
        getPoliciesDetailsForInsuredData,
        filterTypeByCriteriaType,
        selectedGridItem,
        setSelectedGridItem,
        selectedItemDetailFromGrid,
        documentType,
        setDocumentType,
        setDocumentClass,
        documentClass,
        userGroups,
        setUserGroups,
        queues,
        setQueues,
        user,
        setUsers,
        taskTypes,
        setTaskTypes,
        checkList,
        accessToken,
        priorityList,
        setCheckList,
        getLocationSpecificInfo,
        loading, 
        setLoading
      }}
    >
      {Toaster}
       {open && 
       <AlertPopup
       title= {title} 
       text={text} 
       open={open} 
       handleClose = {()=> {
        setOpen(false);
        setTitle("");
        setText("");
        }}/>}
      {children}
    </TaskPaneContext.Provider>
  );
};

export const useTaskPane = () => {
  const taskPaneContext = useContext(TaskPaneContext);

  if (!taskPaneContext) {
    throw new Error("hook canot be used outside of the TaskPaneProvider");
  }
  return taskPaneContext;
};